import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import checkout from '../store/checkout';

import CheckoutFinishComponent from './CheckoutFinish.component';
import CheckoutVerifyComponent from './CheckoutVerify.component';

import FormCheckoutFactory from '../factories/FormCheckout.factory';

import { CHECKOUT_STEPS } from '@giro-app/modules/checkout/constants/stepsFormCheckout.constant';

import { flow } from 'lodash';
import list from '@giro-app/modules/debts/store/list';

const CheckoutComponent = ({ isValid }) => {
  const dispatch = useDispatch();
  const selectorRedux = {
    currentStep: useSelector(checkout.selector.selectCurrentStep),
  };

  const selectorAppsRedux = {
    isPartner: useSelector(list.selector.selectIsPartner),
  };

  const isFirstStep = selectorRedux.currentStep === null;

  const dispatchRedux = {
    servicePost: flow(list.action.servicePostTokenPartner, dispatch),
    error: useSelector(list.selector.selectError),
  };

  React.useEffect(() => {
    if (selectorAppsRedux.isPartner && isValid) {
      dispatchRedux.servicePost();
    }
  }, []);

  return (
    <Box
      height="100%"
      display="grid"
      gridTemplateColumns="1fr"
      gap={4}
      minHeight="calc(100vh - 410px)"
      alignItems="start"
      width="100%"
    >
      {(isFirstStep ||
        selectorRedux.currentStep === CHECKOUT_STEPS.ANTIFRAUD_ADDRESS) && (
        <Box>
          <FormCheckoutFactory variant="antiFarudAddress" isValid={isValid} />
        </Box>
      )}

      {selectorRedux.currentStep === CHECKOUT_STEPS.PAYMENT && (
        <Box>
          <FormCheckoutFactory variant="payment" isValid={isValid} />
        </Box>
      )}

      {selectorRedux.currentStep === CHECKOUT_STEPS.VERIFY && isValid && (
        <CheckoutVerifyComponent />
      )}

      {selectorRedux.currentStep === CHECKOUT_STEPS.FINISH && isValid && (
        <CheckoutFinishComponent />
      )}
    </Box>
  );
};

export default CheckoutComponent;
